var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplicationHeaderLink',{attrs:{"id":"applicationConnector__mobile","buttonConfig":_vm.computedConfig},nativeOn:{"click":function($event){return _vm.$emit('connect')}}})}
var staticRenderFns = []

export { render, staticRenderFns }